import { render, staticRenderFns } from "./FollowUpCard.vue?vue&type=template&id=070a5db7"
import script from "./FollowUpCard.vue?vue&type=script&lang=js"
export * from "./FollowUpCard.vue?vue&type=script&lang=js"
import style0 from "./FollowUpCard.vue?vue&type=style&index=0&id=070a5db7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports